module.exports = __webpack_public_path__ + "img/gal-5.4114ded4.jpeg";